import { useEffect, useState } from "react";
import { isPinSurface } from "@/desktop/pin/desktop-pin-surface";

const GLASS_BACKED_HTML_FRAME_ATTRIBUTES = [
  "data-desktop-denk",
  "data-desktop-denk-workspace",
];

// A desktop widget shows the page on its own material, with no backdrop of
// the page's own; the wall card and the opened window keep the backdrop.
function hasGlassBackedHtmlFrameSurface(): boolean {
  if (typeof document === "undefined") return false;
  if (isPinSurface()) return true;
  const { dataset } = document.documentElement;
  return (
    dataset.desktopDenk === "true" || dataset.desktopDenkWorkspace === "true"
  );
}

export function useGlassBackedHtmlFrameSurface(): boolean {
  const [enabled, setEnabled] = useState(hasGlassBackedHtmlFrameSurface);

  useEffect(() => {
    const root = document.documentElement;
    const observer = new MutationObserver(() => {
      setEnabled(hasGlassBackedHtmlFrameSurface());
    });
    observer.observe(root, {
      attributes: true,
      attributeFilter: GLASS_BACKED_HTML_FRAME_ATTRIBUTES,
    });
    return () => observer.disconnect();
  }, []);

  return enabled;
}
